import { render, staticRenderFns } from "./HeaderTop.vue?vue&type=template&id=488b7c6e&scoped=true&"
import script from "./HeaderTop.vue?vue&type=script&lang=js&"
export * from "./HeaderTop.vue?vue&type=script&lang=js&"
import style0 from "./HeaderTop.vue?vue&type=style&index=0&id=488b7c6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488b7c6e",
  null
  
)

export default component.exports